// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__5q5fk","header":"PatientBlock_header__21k7q","label":"PatientBlock_label__XoTqB","option":"PatientBlock_option__2zEbJ"};